import api from "./axiosInstance";

/**
 * Dashboard API Service
 * Handles all dashboard related API calls
 */

export const dashboardApi = {
  /**
   * Get dashboard data
   * GET /api/v1/challans/getDashboardData
   */
  getDashboardData: () => {
    return api.get("challans/getDashboardData");
  },

  /**
   * Get combined challan product data
   * GET /api/v1/challans/searchChallans?challanType=COMBINED
   */
  getCombinedChallanProductData: (params = {}) => {
    const defaultParams = { challanType: 'COMBINED', page: 0, size: 100 };
    return api.get("challans/searchChallans", { 
      params: { ...defaultParams, ...params } 
    });
  },

  /**
   * Get combined challan count
   * GET /api/v1/challans/searchChallans?challanType=COMBINED
   */
  getCombinedChallanCount: () => {
    return api.get("challans/searchChallans", { 
      params: { challanType: 'COMBINED', page: 0, size: 1 } 
    });
  },

  /**
   * Get product-wise report (delivered/received per product)
   * GET /api/v1/reports/products
   */
  getProductWiseReport: (params = {}) => {
    return api.get("reports/products", { params });
  },

  /**
   * Get recent challans for movement history
   * GET /api/v1/challans/searchChallans with recent date filter
   */
  getRecentChallans: (params = {}) => {
    const defaultParams = { page: 0, size: 20, sortBy: 'date', direction: 'DESC' };
    return api.get("challans/searchChallans", { 
      params: { ...defaultParams, ...params } 
    });
  }
};

export default dashboardApi;
